module.exports = __webpack_public_path__ + "img/ic_appstore_logo@2x.434b07cc.png";